import { updateAiCompetitorsSession } from "./aiCompetitorsApi";
import { LaunchError } from "../../utils/errors";
import { store } from "../../app/store";
import {
  getAiCompetitorsCalLink,
  getAiCompetitorsThanksUrl,
} from "./aiCompetitorsConstants";

export const redirectToAiCompetitorsThanksAfterBooking = ({
  sessionId = "",
  language = "en",
  calLink,
} = {}) => {
  const nextCalLink = calLink || getAiCompetitorsCalLink(language);
  if (sessionId) {
    updateAiCompetitorsSession({
      sessionId,
      booking: {
        intent: "booked",
        calLink: nextCalLink,
      },
    }).catch((error) => {
      store.dispatch(
        LaunchError(error, false, [], {
          functionName: "redirectToAiCompetitorsThanksAfterBooking",
          capture: "exception",
          context: { sessionId },
        })
      );
    });
  }
  window.location.replace(getAiCompetitorsThanksUrl(language));
};
